export default [
	{ text: 'LEFT', value: 'LEFT' },
	{ text: 'RIGHT', value: 'RIGHT' },
	{ text: 'BOTH', value: 'BOTH' },
	{ text: 'NONE OF THE ABOVE', value: 'NONE OF THE ABOVE' }
];



// WEBPACK FOOTER //
// ./src/data/eyes.js